import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { LocationStrategy } from '@angular/common';
import { EnvironmentConfig } from '../../../environments/environmentConfig';
import { ApplicantDetailsService } from 'src/app/service/applicant-details.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { PREQUAL_DATA } from "../../dummy_data/dummy_prequalData";
import { AdobeAnalyticsDigitalDataService } from 'src/app/service/adobe-analytics-digitaldata.service';
@Component({
  selector: 'personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.less'],
  providers: [FrameworkUtilityComponent, EnvironmentConfig]
})
export class PersonalInformationComponent implements OnInit {
  $: any;
  currentLang: string;
  showForm: boolean = false;

  personalArray = [];
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';
  personalInfoObj: any = {
    address: "",
    mobilenumber: "",
    email: "",
    lastname: "",
    firstname: ""
  };
  enumData: any;
  compDataObj = {
    display: false
  };
  preQualData: any;
  sampleData: any;
  currentRoutePath: string;
  privacyandsecurityLink: string;

  progressPercent: CONSTANTS.PROGRESS_PERCENTAGE;
  hideShowPopup: boolean = false;
  isPageLoaded = 0;
  isIosDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
  @ViewChild('ert') popovermdl: any;
  @ViewChild('focusTrap') focusTrap: any;
  popoverobj: any;
  constructor(private modalService: NgbModal, private changeDef: ChangeDetectorRef, private util: UtilService, private _activatedRoute: ActivatedRoute,
    private i18nService: I18nService, private formUtiObj: FrameworkUtilityComponent, private router: Router,
    private applicanDetails: ApplicantDetailsService,
    private translate: TranslateService,
    private location: LocationStrategy,
    private adobeAnalyticsData: AdobeAnalyticsDigitalDataService
  ) {
    sessionStorage.removeItem("olbRedirect");
    this.translate.get('footer.privacyandsecurityLink').subscribe((res: string) => {
      this.privacyandsecurityLink = res || "";
    });
  }

  ngOnInit(): void {
    this.currentLang = this.i18nService.getCurrentLang();
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
    history.pushState(null, null, window.location.href);
    window.onpopstate = () => setTimeout(() => {
    }, 0);

    setTimeout(() => {
      this.enumData = this.util.getEnumData();
      if (!this.enumData) {
        this.util.loadData().subscribe((enumData: any) => {
          this.enumData = enumData.body.data;
          if (this.currentLang.toUpperCase() == "FR") {
            this.enumData.YES_OR_NO = this.enumData.YES_OR_NO_FR
          }

        })

      } else {
      }
      this.applicanDetails.getApplicantDetails().subscribe((data: any) => {

        setTimeout(() => {
          this.util.setSessionStorage(data);
          sessionStorage.setItem('isAuthenticated', "yes");

          if (environment.env != 'local') {
            this.preQualData = data;
            if (this.preQualData.flow_type == this.switchType) {
              this.adobeAnalyticsData.load("personal-information")
            }
          }
          if (environment.env == 'local') {
            this.preQualData = this.util.getSessionStorage();
            if (!this.preQualData.users) {
              this.preQualData.users = [];
            }
            if ((this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal || this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.noVal) && this.preQualData.are_both_applicants_CIBC_customer == CONSTANTS.applicationConstants.noVal) {
              this.preQualData['users'][0] = PREQUAL_DATA.users[0];
            }
            else if (this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal && this.preQualData.are_both_applicants_CIBC_customer == CONSTANTS.applicationConstants.yesVal) {
              this.preQualData['users'] = PREQUAL_DATA.users;
            }
            this.util.setSessionStorage(this.preQualData);
            if (this.preQualData.flow_type == this.switchType) {
              this.adobeAnalyticsData.load("personal-information")
            }
          }
          for (let i = 0; i < this.preQualData.users.length; i++) {
            this.personalInfoObj = this.preQualData.users[i];
            this.personalInfoObj.address = this.personalInfoObj.addressline1 + "<br/> " + this.personalInfoObj.city + " " + this.personalInfoObj.province + "<br/>" + this.personalInfoObj.postal_code;
            if (!this.personalInfoObj.mobilenumber  ) {
              this.personalInfoObj.mobilenumber = this.personalInfoObj.homenumber
            }

            if (this.personalInfoObj.mobilenumber && this.personalInfoObj.homenumber) {
              if (this.personalInfoObj.homenumber.length == 10) {
                this.personalInfoObj.mobilenumber = this.personalInfoObj.homenumber.slice(0, 3)+ "-"+ this.personalInfoObj.homenumber.slice(3, 6)+ "-"+ this.personalInfoObj.homenumber.slice(6);
              }
            }
            else {
              if (this.currentLang == this.currLangEn) {
                this.personalInfoObj.mobilenumber = "Not on file";
              } else {
                this.personalInfoObj.mobilenumber = "Non disponsible";

              }
            }
            if (!this.personalInfoObj.email) {
              if (this.currentLang == this.currLangEn) {
                this.personalInfoObj.email = "Not on file";
              } else {
                this.personalInfoObj.email = "Non disponsible";

              }
            }
            this.personalArray.push(this.personalInfoObj);
          }
          console.log(this.personalArray, "personalArrayData");

          if (environment.env != 'local') {
            if (data.users.length > 2) {
              this.router.navigate(['../' + sessionStorage.getItem("currLang") + '/home'], { relativeTo: this._activatedRoute });
            }
          }
          this.showForm = true
        }, 200);
      })
      this._activatedRoute.url.subscribe(route => {
        this.currentRoutePath = route[0].path;
      });
    }, 0);
  }
  onContinue() {
    if (this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal && this.preQualData.are_both_applicants_CIBC_customer == CONSTANTS.applicationConstants.noVal) {
      this.router.navigate(['../co-applicant-flow-start'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
    }
    if (this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.yesVal && this.preQualData.are_both_applicants_CIBC_customer == CONSTANTS.applicationConstants.yesVal) {
      this.router.navigate(['../income'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
    }
    if (this.preQualData.is_coapplicant_applied == CONSTANTS.applicationConstants.noVal) {
      this.router.navigate(['../income'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
    }
  }
}